import { useState } from "react";
import { useEffect } from "react";

import { Grid } from "@mui/material";
import { v4 as uuid } from "uuid";

import OmniTextField from "../ui/omniTextField";

const QuestionTextDisplay = props => {
  const { question, onAnswerSelected } = props;

  const [localAnswer, setLocalAnswer] = useState("");

  useEffect(() => {
    onAnswerSelected([localAnswer]);
  }, [localAnswer, onAnswerSelected]);

  useEffect(() => {
    if (question && question.answerValue && question.answerValue[0]) {
      setLocalAnswer(question.answerValue[0]);
    }
  }, [question, setLocalAnswer]);

  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={11}>
        <OmniTextField
          key={`answerOptionQuestion${question.omniID}`}
          name={uuid()}
          value={localAnswer}
          label={question.answerOptions[0].text}
          placeholder={question.answerOptions[0].helpText}
          onChange={e => setLocalAnswer(e.target.value)}
          sx={{ textAlign: "center" }}
          onFocus={event => event.target.select()}
        />
      </Grid>
    </Grid>
  );
};

export default QuestionTextDisplay;
